import React, { Component } from 'react';
import { Translation } from "react-i18next";
import WarningIcon from '../../../../images/Warning-Filled Icon.svg';
import './error-reload.scss'

/**
 * Component that shows the error message when another component failed to be loaded and offers a "reload" button.
 */

type Props = {
    message: string
    reverseOnMobile: boolean,
    onReloadClick: () => void
}

class ErrorReload extends Component<Props> {
    getMessage() {
        return this.props.message
            ? this.props.message
            : <Translation>{t => t("Unfortunately we could not load this component.")}</Translation>;
    }

    getMessageElement() {
        return (
            <div className="message">
                <img src={WarningIcon} alt="Warning icon" />
                <span>{this.getMessage()}</span>
            </div>
        );
    }

    getButtonElement() {
        return (
            <button className="reload-button" onClick={this.props.onReloadClick}>
                <Translation>{t => t("Reload")}</Translation>
            </button>
        );
    }

    render() {
        const messageEl = this.getMessageElement();
        const buttonEl = this.getButtonElement();

        return (
            <div className='error-reload-container'>
                {messageEl}
                {buttonEl}
            </div>
        );
    }
}

export default ErrorReload;